<template>
    <BaseModal
        :variant="showSignUp ? 'prospus-bg-blue' : 'prospus-bg-glory-red'"
    >
        <template #header>
            <div class="prospus-modal__header--actions px-5 py-2">
                <img
                    src="/images/auth/logo-black.svg"
                    class="prospus-logo"
                    alt="kaamfu-logo-modal"
                />
                <span
                    class="prospus-close auth-modal-text-on-dark"
                    :class="`prospus-visibility-${isCanceled ? 'hide' : 'show'}`"
                    @click="showCancelRegistrationOption"
                    >&times;</span
                >
            </div>
            <h3 class="prospus-title light">
                <template v-if="isCanceled">
                    Are you sure you want to cancel your Kaamfu registration?
                </template>
                <template v-else-if="showSignUp">
                    We just sent a validation code to your email.
                    <p>Enter the code below:</p>
                </template>
                <template v-else>
                    You still need to validate your email account.
                </template>
            </h3>
        </template>
        <div
            v-if="isCanceled"
            class="prospus-flex prospus-flex-column prospus-flex-end prospus-my-auto"
        >
            <VBtn
                variant="flat"
                color="buttonBg"
                hover-bg="bg-secondary"
                class="px-3 text-none text-fontLight w-100"
                :style="{ fontWeight: 400, height: '29px' }"
                @click="showOTP"
            >
                No, do not cancel my registration
            </VBtn>
            <VBtn
                variant="plain"
                color="icon"
                class="px-3 text-none prospus-mt-20"
                :style="{ fontWeight: 400, height: '29px' }"
                @click="$emit('reset')"
            >
                Yes, please cancel my registration
            </VBtn>
        </div>
        <div v-else class="prospus-otp-wrap">
            <form
                id="prospus-otp-form"
                class="prospus-form"
                @submit.prevent="validateOTP"
                @keyup.enter.prevent="validateOTP"
            >
                <!-- <span>OTP</span> -->
                <div
                    class="input-wrapper prospus-has-validation-check password-validation"
                >
                    <div class="input-wrapper__inner">
                        <button
                            class="hint-mode otp-hint-btn"
                            tabindex="-1"
                            type="button"
                            @mouseover="showTooltip = true"
                            @mouseout="showTooltip = false"
                        >
                            <span
                                v-if="otpValue.length == 0"
                                class="material-icons otp-hint-icon"
                            >
                                pin
                            </span>
                            <span
                                v-else-if="isSuccessful"
                                class="material-icons otp-hint-icon"
                            >
                                task_alt
                            </span>
                            <span v-else class="material-icons otp-hint-icon"
                                >info_outline</span
                            >
                        </button>
                        <OtpInput
                            ref="refInputOTP"
                            class="prospus-otp-input-wrap"
                            :num-inputs="5"
                            seperator=""
                            :should-auto-focus="true"
                            :is-input-num="true"
                            @on-change="onOtpEntered"
                            @on-complete="onOtpEntered"
                            @focusin="showTooltip = true"
                            @focusout="showTooltip = false"
                        >
                        </OtpInput>
                        <!-- <a
                            class="prospus-link prospus-ml-20 prospus-mt-10 prospus-text-xs prospus-fs-i text-white"
                            @click="clearOTP"
                        >
                            CLEAR
                        </a> -->
                        <VBtn
                            variant="plain"
                            color="icon"
                            class="px-3 text-uppercase"
                            :style="{ fontWeight: 400, height: '29px' }"
                            @click="clearOTP"
                        >
                            CLEAR
                        </VBtn>
                    </div>
                    <!--Show tooltip
                        Case 1: When user start typing otp
                        Case 2: otp should be valid
                        Case 3: User should entered atleast one charter
                    -->
                    <Tooltip
                        v-if="
                            (error_message &&
                                showTooltip &&
                                otpValue.length != 0 &&
                                otpValue.length < 5) ||
                            isOTPVerifiedInvalid
                        "
                        class="bg-section otp-model-tooltip"
                    >
                        <ul>
                            <li>
                                <span
                                    class="material-icons auth-modal-text-on-dark"
                                    >close</span
                                >
                                {{ error_message }}
                            </li>
                        </ul>
                    </Tooltip>
                </div>
                <div class="prospus-otp-check prospus-flex">
                    <div class="prospus-otp-resent">
                        <span
                            class="prospus-block prospus-pt-10"
                            :class="[
                                isOTPResent
                                    ? 'prospus-visibility-show'
                                    : 'prospus-visibility-hide',
                            ]"
                            >The code has been resent. <br />
                            Please check your spam folder.</span
                        >
                    </div>
                    <div class="prospus-resend-otp">
                        <VBtn
                            variant="plain"
                            color="icon"
                            class="px-3 text-uppercase"
                            :style="{ fontWeight: 400, height: '29px' }"
                            @click="resentOTP"
                        >
                            Resend code
                        </VBtn>
                    </div>
                    <div class="prospus-submit">
                        <VBtn
                            variant="flat"
                            color="buttonBg"
                            hover-bg="bg-secondary"
                            class="px-3 text-uppercase text-fontLight"
                            :style="{ fontWeight: 400, height: '29px' }"
                            type="submit"
                            :disabled="isRequestInProgress || !isValidOtpLength"
                            :loading="showLoader"
                        >
                            Verify
                        </VBtn>
                    </div>
                </div>
                <div class="prospus-flex prospus-cancel-registration">
                    <VBtn
                        variant="plain"
                        color="icon"
                        class="ml-auto px-3 text-uppercase"
                        :style="{ fontWeight: 400, height: '29px' }"
                        @click="showCancelRegistrationOption"
                    >
                        Cancel my registration
                    </VBtn>
                </div>
            </form>
        </div>
    </BaseModal>
</template>
<script>
import axios from "axios";
import BaseModal from "../Common/BaseModal.vue";
import OtpInput from "../../OTP/Input.vue";
import Tooltip from "../Common/Tooltip.vue";
import { useLogin } from "../../Stores/login";

export default {
    components: {
        BaseModal,
        OtpInput,
        Tooltip,
    },
    emits: ["reset"],
    props: {
        showSignUp: {
            type: Boolean,
            Default: false,
        },
    },
    data() {
        return {
            otpError: "",
            isOTPResent: false,
            otpValue: "",
            showLoader: false,
            isRequestInProgress: false,
            isSuccessful: false,
            showTooltip: false,
            isCanceled: false,
            error_message: "",
            isOTPVerifiedInvalid: false,
        };
    },
    computed: {
        isValidOtpLength() {
            return this.otpValue.length == 5;
        },
        isShowTooltip() {
            return this.otpValue.length > 0;
        },
    },

    methods: {
        async resentOTP() {
            try {
                //requestStarted()
                await axios.post("/resend-otp", {
                    token: useLogin().getToken(),
                });
                this.isOTPResent = true;
                this.clearOTP();
                //requestProcessed();
            } catch (err) {
                //requestProcessed();
            }
        },
        clearOTP() {
            this.$refs.refInputOTP.clearInput();
        },
        async validateOTP() {
            this.error_message = "";
            if (!this.isValidOtpLength) return;

            try {
                this.requestStarted();
                //let user_id = localStorage.getItem('kaamfu_user_id')
                await axios.post("/otp", {
                    otp: this.otpValue,
                    user_id: useLogin().getUserId(),
                    token: useLogin().getToken(),
                });
                this.isSuccessful = true;
                this.goToDashBoard();
                this.requestProcessed();
            } catch (err) {
                this.requestProcessed();
                this.error_message = err?.response?.data?.message;
                this.showTooltip = this.isOTPVerifiedInvalid = true;
            }
        },
        requestStarted() {
            this.isSuccessful = this.otpError = false;
            this.isRequestInProgress = this.showLoader = true;
        },
        requestProcessed() {
            this.isRequestInProgress = false;
            this.showLoader = false;
        },
        goToDashBoard() {
            window.location.reload();
            window.location.href = `${window.location.origin}/`;
        },

        onOtpEntered(value) {
            this.otpValue = value;
            //console.log("otp entered", value)
        },
        showCancelRegistrationOption() {
            this.isCanceled = true;
        },
        showOTP() {
            this.isCanceled = false;
        },
    },
};
</script>
<style lang="scss" scoped>
@import "../../../../sass/_theme-variables.sass";
@import "../../../../sass/_colors.sass";

.otp-hint-btn {
    background-color: $page !important;
}

.otp-hint-icon {
    color: $pauseDark !important;
}

/* Primary: exactly matches AuthIndex/ForgotPassword .btn */
.btn {
    background: $fontLight;
    color: $fontDark;
    padding: 8px 20px;
    border: none;
    font-size: 13.3px;
    font-weight: 500;
    border-radius: 20px;
    margin-left: 15px;
    cursor: pointer;

    &.w-100 {
        width: 100%;
        margin-left: 0;
        text-align: center;
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.45;
    }
}

/* Secondary: exactly matches AuthIndex/ForgotPassword .fp-cancel-link */
.fp-cancel-link {
    color: $fontLight;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
}

.auth-modal-text-on-dark {
    color: $fontLight !important;
}

.otp-model-tooltip {
    :deep(.prospus-tooltip-wrapper__arrow) {
        top: 4px !important;
    }
}
</style>

<style lang="scss">
@import "../../../../sass/_theme-variables.sass";

.prospus-title {
    color: $fontLight !important;
}

#prospus-otp-form.prospus-form {
    background: transparent !important;
    color: $fontLight !important;
}

.prospus-otp-input-wrap input {
    color: $fontLight !important;
    background: transparent !important;
    border-bottom: 2px solid $sectionBorder !important;
}

.prospus-otp-input-wrap input:focus {
    border-bottom-color: $fontLight !important;
}

.prospus-otp-resent span {
    color: $fontLight !important;
}

/* Ensure placeholder text and hints are dimmed */
.prospus-form label {
    color: $fontLight !important;
}
</style>
